/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { Response, CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface CollocationSearchParams extends PageQueryParams {
  search?: string
}

export interface CollocationApiParams {
  page: number
  limit: number
  search?: string
}

export const collocationService = {
  list(params: CollocationApiParams) {
    return HttpRequest.get("v1/collocations", {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },

  detail(id: number) {
    return HttpRequest.get(`v1/collocations/${id}`).json<Response>()
  },
}
